<template>
  <div class="wrapper">
    <side-bar>
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/overview">
        <i class="nc-icon nc-chart-pie-35"></i>
        <p>Dashboard</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps">
        <i class="nc-icon nc-pin-3"></i>
        <p>Mapa</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/table-list">
        <i class="nc-icon nc-notes"></i>
        <p>Lista Vehículos</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/table-list-tags">
        <i class="nc-icon nc-square-pin"></i>
        <p>Lista Localizadores</p>
      </sidebar-link>
      <sidebar-link to="/admin/expense-management">
        <i class="nc-icon nc-money-coins"></i>
        <p>Gestión de gastos</p>
      </sidebar-link>
      <sidebar-link v-if="rol != 2" to="/admin/user">
        <i class="nc-icon nc-circle-09"></i>
        <p>Usuario</p>
      </sidebar-link>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";
//import io from 'socket.io-client';
import getSecret from "../helpers/get-secret";
const serverUrl = getSecret("SERVER_URL");
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      id_company: JSON.parse(localStorage.getItem("jwt_licencia")).id_company,
      name_company: JSON.parse(localStorage.getItem("jwt_licencia")).name,
      token: window.localStorage.getItem("jwt_token"),
      email: JSON.parse(localStorage.getItem("jwt_user")).email,
      listVehicles: [],
      listTags: [],
      rol: JSON.parse(localStorage.getItem("jwt_user")).rol,
      soundBack: "SD_ALERT_23.mp3",
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    getListVehicles() {
      this.$vs.loading({
        type: "point",
        text: "Consultando...",
        color: "#004aad",
      });

      const vehiclesRequest = this.axios.get(
        `${serverUrl}/api/getV2ListVehicles/${this.id_company}`
      );
      const tagsRequest = this.axios.get(
        `${serverUrl}/api/getListTags/${this.id_company}`
      );

      Promise.all([vehiclesRequest, tagsRequest])
        .then(([vehiclesRes, tagsRes]) => {
          if (vehiclesRes.data.status === 200) {
            this.listVehicles = vehiclesRes.data.vehicles;
            this.$root.$emit("send", this.listVehicles);
          } else {
            console.log("Error al obtener vehículos:", vehiclesRes.data);
          }

          if (tagsRes.data.status === 200) {
            this.listTags = tagsRes.data.tags;
            this.$root.$emit("send_tag", this.listTags);
          } else {
            console.log("Error al obtener tags:", tagsRes.data);
          }
        })
        .catch((error) => {
          console.error("Error en las peticiones:", error);
        })
        .finally(() => {
          this.$vs.loading.close();
          this.toggleSidebar();
        });
    },

    playSound(sound) {
      if (sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
  },
  watch: {},
  beforeMount() {
    this.$root.$on("getList", (data) => {
      this.getListVehicles();
    });
  },
  mounted() {
    /*
    this.socket = io('https://backgps.isolutions.website:3000');
    this.socket.on("connect", () => {
        console.log("Socket Conectado");
      });
    this.socket.on("disconnect", () => {
      console.log("Socket Desconectado");
    });
    this.socket.on("alert", (data)=> {
      const dataSocket = parseFloat(data);
      if(this.listVehicles.some(objeto => objeto.cuenta === dataSocket)){
        setTimeout(()=>{ this.getListVehicles() }, 100);
        this.$root.$emit("eventsAlerts");
        this.playSound(this.soundBack);
        this.$notifications.notify({
              message: `<span><b>¡Alerta!</b><br>Alerta de Vehículo Recibida.</span>`,
              icon: 'nc-icon nc-bell-55',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'warning'
            })
      }
    });
    */
  },
};
</script>
